import { render, staticRenderFns } from "./PaymentDibs.vue?vue&type=template&id=542f83ed&"
import script from "./PaymentDibs.vue?vue&type=script&lang=js&"
export * from "./PaymentDibs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports